import React, { useState, useEffect } from 'react';
import style from './InfoButton.module.css';

const InfoButton = ({ icon, className, data, tableClassName, left }) => {
  const [showMenu, setShowMenu] = useState(false);
  const [isAnimating, setIsAnimating] = useState(false);
  const ClassName = className || '';

  const handleToggleMenu = (e) => {
    if (data && !data.length) {
      return false;
    }
    e.stopPropagation();
    setIsAnimating(!showMenu);
    setShowMenu(!showMenu);
    document.body.style.overflow = !showMenu ? 'hidden' : '';
  };

  useEffect(() => {
    const handleEsc = (event) => {
      if (event.keyCode === 27) {
        setShowMenu(false);
        document.body.style.overflow = '';
      }
    };

    window.addEventListener('keydown', handleEsc);

    return () => {
      window.removeEventListener('keydown', handleEsc);
      document.body.style.overflow = '';
    };
  }, []);

  const handleItemClick = (onClick) => {
    setShowMenu(false);
    document.body.style.overflow = '';
    if (onClick) onClick();
  };

  const DropdownMenu = () => (
    <div className={tableClassName ? tableClassName : ''}>
      <div
        className={`${style.backdrop} ${
          isAnimating ? style.animateIn : style.animateOut
        }`}
        onClick={handleToggleMenu}
      ></div>

      <div
        className={`${style['dropdown-menu']} ${
          left ? style.left : style.right
        } ${isAnimating ? style.animateIn : style.animateOut}`}
        onClick={(e) => e.stopPropagation()}
      >
        {data.map((item, index) => (
          <div
            key={index}
            className={style.item}
            onClick={() => handleItemClick(item.onClick)}
          >
            <img src={item.icon} alt={item.label} />
            <p>{item.label}</p>
          </div>
        ))}
      </div>
    </div>
  );

  return (
    <div className={tableClassName ? '' : ClassName}>
      <div
        className={style['info-button']}
        onClick={(e) => {
          handleToggleMenu(e);
        }}
      >
        <img src={icon} alt="Info" />
      </div>

      {showMenu && <DropdownMenu />}
    </div>
  );
};

export default InfoButton;
